import {Component} from "@angular/core";

@Component({
    selector : 'home',
    template: require('./home.component.html')
})

export class HomeComponent {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/home.component.ts